export default {
  // Set meetings loaded state to true
  meetingsTimestamp(state) {
    state.meetingsLoaded = String(Math.round(new Date().getTime() / 1000));
  },
  // Reset meetigs timestamp
  meetingsTimestampReset(state) {
    state.meetingsLoaded = null;
  },
  // Set meetings state
  meetings(state, payload) {
    state.meetings = payload;
  },
};
